import { Autocomplete, Chip, TextField } from "@mui/material";
import { useAsync2 } from "nate-react-api-helpers";
import { api } from "../../../api/API";
import { TeamMember } from "../../../api/Teams";

// AssigneePicker picks who a task is assigned to, from the members of its team. A task
// always has one, so the last chip has no remove button.
export function AssigneePicker(props: {
    team: number;
    value: number[];
    onChange: (value: number[]) => void;
    placeholder?: string;
}) {
    const members = useAsync2(input => input.team ? api.teams.listMembers(input) : Promise.resolve(null),
        { team: props.team }, [props.team]);

    const options = members.result?.members || [];
    const selected = options.filter(member => props.value.includes(member.usr));

    return (
        <>
            <Autocomplete
                multiple
                disableClearable
                size="small"
                options={options}
                value={selected}
                getOptionLabel={(member: TeamMember) => member.name}
                isOptionEqualToValue={(a: TeamMember, b: TeamMember) => a.usr === b.usr}
                onChange={(_, value: TeamMember[]) => {
                    if (value.length === 0) return;
                    props.onChange(value.map(member => member.usr));
                }}
                renderValue={(value: TeamMember[], getItemProps) => value.map((member, index) => {
                    const { key, onDelete, ...itemProps } = getItemProps({ index });

                    return (
                        <Chip key={key} {...itemProps} size="small" label={member.name}
                              // the chips naming the assignees ride at the row's height
                              sx={{ height: 20, fontSize: 12 }}
                              onDelete={value.length > 1 ? onDelete : undefined} />
                    );
                })}
                renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder={props.placeholder === undefined ? "Assignee" : props.placeholder}
                        sx={{ "& .MuiAutocomplete-input": { py: 0.25 } }}
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                disableUnderline: true,
                                // line the text up with the project field above it
                                style: { fontSize: "0.8125rem", paddingLeft: 6 },
                            },
                        }}
                    />
                )}
            />
            {members.LoadingOrErrorElement}
        </>
    );
}
